import type { JSX } from 'react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// The auth-module AuthLayout clone was removed with the login/verify cutover
// (ADR-018); the sign-out page reuses the identical access-module frame.
import { AuthLayout } from '../access/AuthLayout';

export function LogoutPage(): JSX.Element {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [userName, setUserName] = useState<string | null>(null);

  useEffect(() => {
    const logout = async () => {
      try {
        // Fetch user info to get their name before clearing auth
        try {
          const meRes = await fetch('/api/me', { credentials: 'include' });
          if (meRes.ok) {
            const me = (await meRes.json()) as {
              contact?: { Preferred_Name?: string; First_Name?: string };
            };
            const name = me.contact?.Preferred_Name || me.contact?.First_Name;
            if (name) setUserName(name);
          }
        } catch {
          // Continue with logout even if we can't fetch user info
        }

        await fetch('/api/auth/logout', {
          method: 'POST',
          credentials: 'include',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });
      } catch (err) {
        console.error('logout request failed', err);
      } finally {
        localStorage.removeItem('auth_email');
        setLoading(false);
      }
    };

    logout();
  }, []);

  return (
    <AuthLayout>
      <div className="mx-auto max-w-sm">
        <div className="panel space-y-4 text-center">
          <h2 className="mb-3 text-lg font-semibold text-ccaanz-black">
            {loading ? 'Signing out...' : "You're all set"}
          </h2>
          <p className="mb-6 text-sm text-ccaanz-grey">
            {loading ? (
              "We're logging you out of the Parish Portal."
            ) : (
              <>
                Thank you for your work today{userName && `, ${userName}`}. You have been signed out
                securely.
              </>
            )}
          </p>

          {!loading && (
            <p className="mb-6 text-xs text-ccaanz-grey">
              If you need to review something quickly, you can use your browser's back button for 30
              seconds.
            </p>
          )}

          <button
            onClick={() => navigate('/auth/login')}
            disabled={loading}
            className="btn btn-primary"
          >
            {loading ? 'Signing out...' : 'Sign In Again'}
          </button>
        </div>
      </div>
    </AuthLayout>
  );
}
